import GeneralTableComponent from 'components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import GeneralSearchComponent from 'components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import React, {
  useEffect, useState,
} from 'react';
import {
  useObserver,
} from 'mobx-react';
import {
  stores,
} from 'mobx-store';
import {
  useHistory,
} from 'react-router';
import {
  translate,
} from 'helperFunctions/translation';
import {
  TableCellTypes,
} from 'components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';

const DEFAULT_PAGE_SIZE = 50;
const DEFAULT_PAGE_NUMBER = 1;

const WifiPackagesSubscriptionScreen: React.FC = () => {
  const {
    wifiPackagesStore,
  } = stores;
  const history = useHistory();

  const [pageSize] = useState(DEFAULT_PAGE_SIZE);
  const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);
  const [searchTitle, setSearchTitle] = useState('');

  const userSubscriptionDetails = (index: number) => {
    const {
      userId,
    } = wifiPackagesStore.usersWifiPackagesSubscriptions[index] || {
    };
    history.push(`/users/${userId}/wifi-packages`);
  };

  const WIFI_SUBSCRIPTION_CELLS_TYPES: TableCellTypes [] = [
    {
      key: 'userId',
      cellType: 'Text',
    },
    {
      key: 'membershipId',
      cellType: 'Text',
    },
    {
      key: 'email',
      cellType: 'Text',
    },
    {
      key: 'phoneNumber',
      cellType: 'Text',
    },
    {
      key: 'details',
      cellType: 'Button',
      onClick: (index: number) => userSubscriptionDetails(index),
    },
  ];
  const WIFI_SUBSCRIPTION_TABLE_HEADER = [
    {
      title: 'user id',
    },
    {
      title: 'membership id',
    },
    {
      title: 'email',
    },
    {
      title: 'phone',
    },
    {
      title: 'details',
    },
  ];

  const getUsersWifiPackagesSubscriptions = () => (
    wifiPackagesStore.usersWifiPackagesSubscriptions.map((uws) => ({
      ...uws,
      details: translate('details'),
    }))
  );

  const leftArrowClicked = () => setPageNumber(pageNumber - 1);
  const rightArrowClicked = () => setPageNumber(pageNumber + 1);

  useEffect(() => {
    if (searchTitle.length > 0) {
      wifiPackagesStore.getUsersWifiPackagesSubscription(pageNumber, pageSize, searchTitle);
    } else {
      wifiPackagesStore.getUsersWifiPackagesSubscription(pageNumber, pageSize, '');
    }
  }, [pageNumber]);

  const handleSearchChanged = async (title: string) => {
    setSearchTitle(title);
    setPageNumber(1);
    await wifiPackagesStore.getUsersWifiPackagesSubscription(pageNumber, pageSize, title);
  };

  return useObserver(() => (
    <>
      <div>
        <GeneralSearchComponent
          onSearchClick={handleSearchChanged}
          searchBy="title"
          onClearSearch={() => handleSearchChanged('')}
        />
      </div>
      <GeneralTableComponent
        emptyMessage={translate('settingsListNoSettingsMessage')}
        title={translate('wifiSubscriptions')}
        tableHeader={WIFI_SUBSCRIPTION_TABLE_HEADER}
        tableData={getUsersWifiPackagesSubscriptions()}
        tableCellTypes={WIFI_SUBSCRIPTION_CELLS_TYPES}
        loadingStatus={[
          wifiPackagesStore.state,
        ]}
        hadPagination
        paginationAction={{
          handleClickLeftArrow: leftArrowClicked,
          handleClickRightArrow: rightArrowClicked,
          pageNumber,
          totalNumberOfPages: Math.ceil(wifiPackagesStore.usersWifiPackagesSubscriptionsCount / pageSize)
        }}
      />
    </>
  ));
};

export default WifiPackagesSubscriptionScreen;
